//@flow
import React, { Component } from 'react';
import { Desktop, Default, Device } from '../../../components/Responsive';
import { ModelListTh } from '../../../components/ModelListStyles';
import DefaultModelRowTr from '../../../modules/CrudTable/components/DefaultModelRowTr';

type Props = {};
export default class TableHeader extends Component<Props> {
  render() {
    return (
      <DefaultModelRowTr>
        <Desktop>
          <ModelListTh>Currency</ModelListTh>
        </Desktop>
        <Device>
          <ModelListTh>Transaction sum</ModelListTh>
        </Device>
        <Desktop>
          <ModelListTh right>Transaction sum</ModelListTh>
        </Desktop>
        <Default>
          <ModelListTh right>Fees</ModelListTh>
        </Default>
        <ModelListTh right>Commission payout</ModelListTh>
      </DefaultModelRowTr>
    );
  }
}
